/*
* Story Theme
*
* Use this file to add custom Javascript to Story.  Keeping your custom
* Javascript in this fill will make it easier to update Story. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {
  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

      

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();

function popOpen() {
  document.getElementById("boxPopup").style.display = "block";
}

function popClose() {
  document.getElementById("boxPopup").style.display = "none";
}

const zoneA = ["67346", "67354", "67373", "68804", "67374", "67376", "68809", "67365", "67166", "68775", "68766", "67105", "68799", "68794", "67165", "67366", "67459"];
const zoneB = ["67368", "67435", "67361", "67360", "68753", "67377", "68723", "67141", "67117", "67363", "68782", "76726", "69190", "67378", "67482", "76661", "68789", "76879", "67454", "67067", "67126", "68219", "67061", "69207", "67122", "76756", "67065", "67059", "67112", "69231", "67149", "67125"];
const zoneC = ["67150", "76771", "67489", "76707", "76879", "76761", "68199", "67434", "76709", "69168", "76661", "76877", "69214", "67152", "67063", "68163", "69242", "67146", "68159", "67487", "67071", "69254", "68165", "67127"];
const zoneD = ["67227", "76829", "67480", "76676", "76835", "76777", "67433", "76694", "69115", "76669", "69123", "76774", "76863", "69181", "76706", "68549", "67466", "67483", "67133", "67157", "76764", "67435", "67136", "68259", "68167", "68307", "76698", "68169", "67245"];
const zoneH = ["69181", "68309", "67158", "76689", "68519", "67256", "67468", "68526", "67159", "76351", "67069", "67258", "76751", "67161", "67240", "68542", "67098", "76870", "69226"];
const zoneI = ["67169", "76744", "67229", "68307", "76855", "67259", "76767", "69245", "76872"];
const zoneJ = ["69493", "68623", "76297", "67547", "76872", "69509"];
const zoneK = ["67471", "64646"];
const zoneL = ["74206", "76317"];

function checkZip() {
    const eingabe = document.getElementById("textInput").value;

    if (zoneA.includes(eingabe)) {
        document.getElementById("ergebnis").textContent = "Kostenlose Lieferung";
    } 
    else if (zoneB.includes(eingabe)) {
        document.getElementById("ergebnis").textContent = "Lieferkosten: 50€";
    }
    else if (zoneC.includes(eingabe)) {
        document.getElementById("ergebnis").textContent = "Lieferkosten: 100€";
    }
    else if (zoneD.includes(eingabe)) {
        document.getElementById("ergebnis").textContent = "Lieferkosten: 200€";
    }
    else if (zoneH.includes(eingabe)) {
        document.getElementById("ergebnis").textContent = "Lieferkosten: 600€";
    }
    else if (zoneI.includes(eingabe)) {
        document.getElementById("ergebnis").textContent = "Lieferkosten: 700€";
    }
    else if (zoneJ.includes(eingabe)) {
        document.getElementById("ergebnis").textContent = "Lieferkosten: 900€";
    }
    else if (zoneK.includes(eingabe)) {
        document.getElementById("ergebnis").textContent = "Kostenlose Lieferung";
    }
    else if (zoneK.includes(eingabe)) {
        document.getElementById("ergebnis").textContent = "Kostenlose Lieferung";
    }
    else {
      document.getElementById("ergebnis").textContent = "Keine Zustellung in diesem Gebiet. Bitte stellen Sie eine Anfrage.";
    }
}

// (function(window) {
//   var cart = document.getElementById("cartbutton");

//   cart.onclick = function() {
//     console.log("test");
//     window.location.replace("/cart");
//   }

// })();



// setTimeout(function(){
//     $("#cartbutton").click(function(){
//         window.location.replace("/cart");
//     }); 
// }, 3000);


